import React from "react";

import { ACTION_ICONS } from "./types";
import {
    PreviewSection,
    PreviewSectionTitle,
    SectionDivider,
    ActionsGrid,
    ActionCard,
    ActionIconCircle,
    ActionTitle,
    ActionDescription,
} from "./styled";

type ActionsSectionProps = {
    actionsEnabled: boolean;
    actionsTitleVisible: boolean;
    actionsSectionTitle: string;
    actionsIconPath: string;
    actionsCustomIcon: string;
    actionsList: Array<{
        id: number;
        icon: string;
        iconColor: string;
        title: string;
        description: string;
        titleVisible: boolean;
        descriptionVisible: boolean;
    }>;
    mainColor: string;
    primaryColor: string;
};

export function ActionsSection({
    actionsEnabled,
    actionsTitleVisible,
    actionsSectionTitle,
    actionsIconPath,
    actionsCustomIcon,
    actionsList,
    mainColor,
    primaryColor,
}: ActionsSectionProps): JSX.Element | null {
    if (!actionsEnabled) return null;

    return (
        <PreviewSection>
            {actionsTitleVisible && (
                <>
                    <PreviewSectionTitle>
                        {actionsCustomIcon ? (
                            <img
                                src={actionsCustomIcon}
                                alt=""
                                style={{
                                    width: 14,
                                    height: 14,
                                    objectFit: "contain",
                                }}
                            />
                        ) : (
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill={primaryColor}
                            >
                                <path d={actionsIconPath} />
                            </svg>
                        )}
                        {actionsSectionTitle}
                    </PreviewSectionTitle>
                    <SectionDivider mainColor={primaryColor} />
                </>
            )}
            <ActionsGrid>
                {actionsList.map((action) => (
                    <ActionCard key={action.id}>
                        <ActionIconCircle
                            bgColor={action.iconColor || mainColor}
                        >
                            <svg viewBox="0 0 24 24">
                                <path
                                    d={
                                        ACTION_ICONS[action.icon] ||
                                        ACTION_ICONS.restaurant
                                    }
                                />
                            </svg>
                        </ActionIconCircle>
                        {action.titleVisible !== false && (
                            <ActionTitle>
                                {action.title || "Action"}
                            </ActionTitle>
                        )}
                        {action.descriptionVisible !== false &&
                            action.description && (
                                <ActionDescription>
                                    {action.description}
                                </ActionDescription>
                            )}
                    </ActionCard>
                ))}
            </ActionsGrid>
        </PreviewSection>
    );
}
